import { createAction, props } from '@ngrx/store';
import { D365CustomerSegment } from '../../common/enums/d365/d365-customer-segment';
import { D365AccountContactData } from '../../common/functions/transformation.functions';
import { DeepPartial } from '../../common/interfaces/deep-partial';
import { AgencyBranchForMonitoring, AgentInfo } from '../../common/models/user/agent';
import { Contact } from '../../common/models/user/contact';
import { CustomerInfo } from '../../common/models/user/customer';
import { GeolocationMonitoring } from '../../common/models/user/geolocation-monitoring';
import { Lead } from '../../common/models/user/lead';
import { DataOwnershipChangeData, MastershipType, UserState } from '../models/user-state';
import { appUserString as c } from './action-types';

export const setUserState = createAction(c.SET_USER_STATE, props<{ s: UserState }>());
export const setContact = createAction(c.SET_CONTACT, props<{ c: Contact; fcrm?: boolean }>());
export const setContactEmail = createAction(c.SET_CONTACT_EMAIL, props<{ email: string }>());
export const setLead = createAction(c.SET_LEAD, props<{ l: Lead; fcrm?: boolean }>());
export const setAgentInfo = createAction(c.SET_AGENT_INFO, props<{ a: AgentInfo }>());
export const setCustomerInfo = createAction(c.SET_CUSTOMER_INFO, props<{ c: CustomerInfo }>());

/**
 *  Resetta le solo le seguenti info all'interno dello user.state
 *    contact: null,
 *    lead: null,
 *    fromCrm: false,
 *    customerInfo: null,
 */
export const resetUserState = createAction(c.RESET_USER_STATE);
export const setLastUsedCustomerSegment = createAction(
    c.SET_LAST_USED_CUSTOMER_SEGMENT,
    props<{ s: D365CustomerSegment }>()
);
export const setCartSegment = createAction(c.SET_CART_SEGMENT, props<{ payload: D365CustomerSegment }>());
export const setVirtualAgentAgencyCurrentBranch = createAction(
    c.SET_VIRTUAL_AGENT_CURRENT_AGENCY_BRANCH,
    props<{ payload: AgencyBranchForMonitoring }>()
);
export const setCustomerMastership = createAction(
    c.SET_CUSTOMER_MASTERSHIP,
    props<{ customerMastership: MastershipType }>()
);

export const setCustomerAndContact = createAction(
    c.SET_CUSTOMER_AND_CONTACT,
    props<{ customer: DeepPartial<D365AccountContactData> }>()
);

export const setDataOwnershipChangeState = createAction(
    c.SET_DATA_OWNERSHIP_CHANGE_STATE,
    props<{ newState: string }>()
);

export const setDataOwnershipChangeData = createAction(
    c.SET_DATA_OWNERSHIP_CHANGE_DATA,
    props<{ data: DataOwnershipChangeData }>()
);

export const setDataGeolocationMonitoring = createAction(
    c.SET_DATA_GEOLOCATION_MONITORING,
    props<{ geolocationMonitoring: GeolocationMonitoring }>()
);
